import { Building, Gauge, Layers, LifeBuoy, Receipt } from 'lucide-react';
import { Shell, type NavItem } from './AppShell';

const PLATFORM_NAME = import.meta.env.VITE_PLATFORM_NAME || 'LeadDesk';

export function PlatformShell() {
  const nav: NavItem[] = [
    { to: '/platform', label: 'Overview', icon: Gauge, end: true },
    { to: '/platform/tenants', label: 'Tenants', icon: Building },
    { to: '/platform/plans', label: 'Plans', icon: Layers },
    { to: '/platform/billing', label: 'Billing', icon: Receipt },
    { to: '/platform/support', label: 'Support', icon: LifeBuoy },
  ];
  return (
    <Shell
      accountPath="/platform/account"
      nav={nav}
      brand={
        <>
          <div
            aria-hidden
            className="flex size-8 items-center justify-center rounded-md bg-fg font-bold text-surface"
          >
            L
          </div>
          <span className="text-base font-semibold text-fg">{PLATFORM_NAME}</span>
          <span className="rounded bg-surface-sunken px-1.5 py-0.5 text-[11px] font-medium uppercase tracking-wide text-fg-muted">
            Console
          </span>
        </>
      }
    />
  );
}
